import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type GetIglooWorksStatusRequest = {
  buildingId: number
}

type IglooWorksConfig = {
  shouldAutoAssignApartmentDoor: boolean
  shouldAutoAssignApartmentDoorVisitor: boolean
  permissionDoors: Record<string, string>
  visitorPermissionDoors: Record<string, string>
}

type IglooWorksStatus = {
  buildingId: number
  clientId: string
  config: IglooWorksConfig
}

export const getIglooWorksStatusQueryKey = (data: GetIglooWorksStatusRequest) => [
  'useGetIglooWorksStatus',
  data,
]

// Reads IglooWorkIntegration straight from our DB (200: stored settings, 404: not
// configured) — IglooWork itself is never called. clientSecret is never returned, same
// write-only treatment as authorizationCode in the Butterfly/RemoteLock providers.
const getIglooWorksStatus = async (data: GetIglooWorksStatusRequest) => {
  const response = await authAPI.get<IglooWorksStatus>(
    `/igloowork/building/${data.buildingId}/integration`,
  )
  return response.data
}

export const useGetIglooWorksStatus = (data: GetIglooWorksStatusRequest) =>
  useQuery({
    enabled: Boolean(data.buildingId),
    queryFn: () => getIglooWorksStatus(data),
    queryKey: getIglooWorksStatusQueryKey(data),
  })
